export default __webpack_public_path__ + "static/media/403b_light.647d23ad.png";